import { FC, ReactNode, createContext, useContext } from 'react';

import chatStoreImpl from './ChatStore';

const storeContext = createContext(chatStoreImpl);

type Props = {
  children: ReactNode;
};

export const ChatStoreProvider: FC<Props> = ({ children }) => {
  return (
    <storeContext.Provider value={chatStoreImpl}>
      {children}
    </storeContext.Provider>
  );
};

export const useChatStore = () => useContext(storeContext);
